// Only show a quality when the stream explicitly states a resolution.
const RESOLUTION = /\b(4320p|2160p|1440p|1080p|720p|480p|360p|8k|4k)\b/gi;

const streamQuality = (stream) => {
    const text = [stream?.name, stream?.description].filter((value) => typeof value === 'string').join(' ');
    const qualities = new Set(Array.from(text.matchAll(RESOLUTION), ([match]) => {
        const value = match.toLowerCase();
        return value === '4320p' || value === '8k' ? '8K' :
            value === '2160p' || value === '4k' ? '4K' : value;
    }));

    return qualities.size === 1 ? [...qualities][0] : null;
};

module.exports = streamQuality;
